import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import snowman from "../images/snowman1.png";
import Colors from "./Colors";
import logo from "../images/logo.png";
import { motion } from "framer-motion";

<style>
  {`
    @keyframes fall {
      0% { transform: translateY(0); opacity: 1; }
      100% { transform: translateY(100vh); opacity: 0; }
    }

    @keyframes sway {
      0%, 100% {
        transform: translateX(0);
      }
      50% {
        transform: translateX(20px);
      }
    }
  `}
</style>;

// Snowflakes Component
const Snowflakes = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      {[...Array(50)].map((_, index) => (
        <Box
          key={index}
          sx={{
            position: "absolute",
            top: "-50px",
            left: `${Math.random() * 100}%`,
            width: `${Math.random() * 6 + 4}px`,
            height: `${Math.random() * 6 + 4}px`,
            background: "#fff",
            borderRadius: "50%",
            animation: "fall 5s linear infinite",
            animationDelay: `${Math.random() * 5}s`,
            opacity: Math.random() * 0.8 + 0.2,
          }}
        />
      ))}
    </Box>
  );
};

// Snowman Image Component
// Snowman Image Component with Sway Animation
const SnowmanImage = () => {
  return (
    <Box
      component="img"
      src={snowman}
      alt="Cute Snowman"
      sx={{
        position: "absolute",
        left: "5%",
        bottom: "10%",
        width: { xs: "80px", sm: "120px", md: "200px" },
        height: "auto",
        zIndex: 2,
        animation: "bounce 2s ease-in-out infinite", // Bounce animation
        "@keyframes bounce": {
          "0%, 100%": {
            transform: "translateY(0)",
          },
          "50%": {
            transform: "translateY(-20px)", // Move the snowman up by 20px
          },
        },
      }}
    />
  );
};

// Banner Content Component
const BannerContent = () => {
  return (
    <Container maxWidth="md" sx={{ position: "relative", zIndex: 3 }}>
      <img
        src={logo}
        alt="Logo"
        style={{ maxWidth: "30%", maxHeight: "16%", objectFit: "cover" }}
      />
      <motion.div
        initial={{ x: "-100%" }}
        animate={{ x: "100%" }}
        transition={{ repeat: Infinity, duration: 15, ease: "linear" }}
      >
        <Typography
          component="p"
          sx={{
            mb: 2,
            fontSize: { xs: "16px", sm: "24px", md: "28px" },
            fontFamily: "Boogaloo",
            letterSpacing: "2px",
            color: Colors.signupBorder, // Light blue for contrast
            whiteSpace: "nowrap",
          }}
        >
          <strong>www.snoword.com</strong>
        </Typography>
      </motion.div>

      <Typography
        variant="h2"
        component="h1"
        sx={{
          fontWeight: "bold",
          mb: 3,
          fontSize: { xs: "2.5rem", sm: "3.5rem", md: "4.5rem" },
          color: "#fff", // White for better readability
          textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
        }}
      >
        Play, Learn, and Win!
      </Typography>
      <Button
        variant="contained"
        color="secondary"
        size="large"
        href="https://www.snoword.com"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          fontWeight: 400,
          fontFamily: "Boogaloo",
          fontSize: "18px",
          px: 4,
          py: 2,
          borderRadius: 2,
          boxShadow: 3,
          background: "#ff6f61", // Red-orange for contrast
          letterSpacing: "2px",
          color: "#fff",
          "&:hover": {
            transform: "scale(1.05)",
            transition: "transform 0.3s ease",
            background: "#ff4a3d", // Darker red-orange on hover
          },
        }}
      >
        Join Now
      </Button>
    </Container>
  );
};

// Main SnowordBanner Component
const SnowordBanner = () => {
  return (
    <Box
      sx={{
        position: "relative",
        background: "linear-gradient(to bottom, #0A0F1F 0%, #1A1A2E 100%)", // Dark blue gradient
        color: "#fff",
        textAlign: "center",
        overflow: "hidden",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
        py: 6, // Add vertical padding
      }}
    >
      {/* Snowman Image */}
      <SnowmanImage />

      {/* Falling Snowflakes */}
      <Snowflakes />

      {/* Banner Content */}
      <BannerContent />

      {/* CSS for Snowflake Animation */}
      <style>
        {`
          @keyframes fall {
            0% { transform: translateY(0); opacity: 1; }
            100% { transform: translateY(100vh); opacity: 0; }
          }
        `}
      </style>
    </Box>
  );
};

export default SnowordBanner;
